<cx-navigation-ui [node]="node$ | async" [ngClass]="styleClass$ | async">
</cx-navigation-ui>
